let elements = {
  /**direction type:
  auto
  top
  bottom
  left
  right
  topleft
  topright
  bottomleft
  bottomright
  lefttop
  leftbottom
  righttop
  rightbottom
  **/

  mainImage: {
    imagePath: 'games/page035_game10/img/bcg2.jpg',
    width: 1430,
    height: 910,
    pos: {
      x: 279,
      y: 138,
    },
  },
  activeArea: {
    width: 50,
    height: 50,
    fontSize: 35,
    backgroundColor: '#f36f1a',
    color: '#ffffff',
  },
  items: [
    {
      id: '10',
      animation: true,
      // direction: 'left',
      textObj: {
        text: 'Obracaj obiekt, trzymając wciśnięty lewy przycisk myszy.',
      },
      audio: {
        src: 'games/page035_game10/audio/z17s35-10.mp3',
        //icon: {
        // audioOn: 'assets/on.png',
        // audioOff: 'assets/off.png',
        //},
        // position: 'top',
      },
      pos: {
        x: 608,
        y: 526,
      },
    },
    {
      id: '10',
      animation: true,
      // direction: 'left',
      textObj: {
        text: 'Obracaj obiekt, trzymając wciśnięty lewy przycisk myszy.',
      },
      audio: {
        src: 'games/page035_game10/audio/z17s35-10.mp3',
        //icon: {
        // audioOn: 'assets/on.png',
        // audioOff: 'assets/off.png',
        //},
        // position: 'top',
      },
      pos: {
        x: 608,
        y: 936,
      },
    },
    {
      id: '10',
      animation: true,
      // direction: 'left',
      textObj: {
        text: 'Obracaj obiekt, trzymając wciśnięty lewy przycisk myszy.',
      },
      audio: {
        src: 'games/page035_game10/audio/z17s35-10.mp3',
        //icon: {
        // audioOn: 'assets/on.png',
        // audioOff: 'assets/off.png',
        //},
        // position: 'top',
      },
      pos: {
        x: 810,
        y: 731,
      },
    },
    {
      id: '11',
      // direction: 'left',
      textObj: {
        text: 'W razie pomyłki użyj przycisku <i>Cofnij.</i>',
      },
      audio: {
        src: 'games/page035_game10/audio/z17s35-11.mp3',
        //icon: {
        // audioOn: 'assets/on.png',
        // audioOff: 'assets/off.png',
        //},
        // position: 'top',
      },
      pos: {
        x: 1519,
        y: 211,
      },
    },
  ],
};
export default elements;
